import { useEffect, useState } from "react";
import { projectApi } from "../backend/client";
import type { ProjectMetadata } from "../backend/api/projects";

const EMPTY_METADATA: ProjectMetadata = {
  statuses: [],
  project_types: [],
};

let request: ReturnType<typeof projectApi.metadata> | null = null;

function loadProjectMetadata() {
  if (!request) {
    request = projectApi.metadata().then((response) => {
      if (response.error) request = null;
      return response;
    });
  }
  return request;
}

export function useProjectMetadata() {
  const [metadata, setMetadata] = useState<ProjectMetadata>(EMPTY_METADATA);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    setLoading(true);

    loadProjectMetadata().then(({ data, error: loadError }) => {
      if (!mounted) return;

      if (loadError || !data) {
        setMetadata(EMPTY_METADATA);
        setError(loadError?.message || "Could not load project options.");
      } else {
        setMetadata(data);
        setError("");
      }
      setLoading(false);
    });

    return () => {
      mounted = false;
    };
  }, []);

  return { metadata, loading, error };
}
